import { JSXElement, lazy } from 'solid-js';
import { AgentPortalPaths, getSlug } from '~/components/AppRouter/utils.ts';
import {
  getAgentPortalPageComponent,
  LayoutTypes
} from '~/components/Layout/utils.tsx';
import { Route } from '@solidjs/router';
import ConnectedAppContextProvider from '~/pages/ScalekitConnect/commons/ConnectedAppContext.tsx';

const AgentPortalConnectedAccount = lazy(
  () => import('~/pages/AgentPortal/AgentPortalConnectedAccount.tsx')
);

export default function AgentPortalRoutes(): JSXElement {
  return (
    <Route path={getSlug.getAgentPortalBaseNamespace()}>
      <Route
        path={getSlug.agentPortalPages(AgentPortalPaths.CONNECTED_ACCOUNT)}
        component={getAgentPortalPageComponent(
          () => (
            <ConnectedAppContextProvider>
              <AgentPortalConnectedAccount />
            </ConnectedAppContextProvider>
          ),
          LayoutTypes.AGENT_PORTAL
        )}
      />
    </Route>
  );
}
